import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../../api/api-client";

const getLandingHeroesFn = async () => {
  const response = await apiClient.get("/v1/landing-pages/heroes");
  return response.data?.data || response.data;
};

export function useLandingHeroes() {
  return useQuery({
    queryKey: ["useLandingHeroes"],
    queryFn: getLandingHeroesFn,
    refetchOnWindowFocus: false,
  });
}
